import dayjs from "dayjs";

import {
  ItemAlignment,
  ButtonItem,
  ItemType,
  TextItem,
  ImageItem,
  HtmlItem,
  FooterItem,
} from "@/@types/flows/emailTemplates/items";

const getCurrentTime = () => dayjs().valueOf();

export const textDefaultBody = (): TextItem => ({
  id: `text-${getCurrentTime()}`,
  type: ItemType.Text,
  text: "Escriba aquí",
  variables: [],
  htmlString: "",
});

export const imageDefaultBody = (): ImageItem => ({
  id: `image-${getCurrentTime()}`,
  type: ItemType.Image,
  image_src: "",
  url: undefined,
  alignment: ItemAlignment.Center,
  htmlString: "",
  width: undefined,
  height: undefined,
});

export const buttonDefaultBody = (): ButtonItem => ({
  id: `button-${getCurrentTime()}`,
  type: ItemType.Button,
  text: "Escribir texto",
  url: "",
  alignment: ItemAlignment.Center,
  backgroundColor: "#262A31",
  foregroundColor: "#FFFFFF",
  fullWidth: false,
  htmlString: "",
});

export const htmlDefaultBody = (): HtmlItem => ({
  id: `html-${getCurrentTime()}`,
  type: ItemType.Html,
  content: "",
  htmlString: "",
});

export const footerDefaultBody = (): FooterItem => ({
  id: `footer-${getCurrentTime()}`,
  type: ItemType.Footer,
  year: "",
  entityName: "",
  email: "",
  backgroundColor: "#F0F0F0",
  htmlString: "",
});
